import * as AlgoSettingsActions from './algo-settings.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { IAlgoSettingState } from '../models/algo-settings.model';

export type State = IAlgoSettingState;

const initialState: State = {
  spanById: {},
  metaCuratorList: [],
  valueSuggestionByAdamType: {},
  columnSuggestionByAdamType: {},
  changes: {},
  lastProjectID: null,
  selectedRow: null,
  loading: false,
  inProgress: false
};

const algoSettingReducer = createReducer(
  initialState,
  on(AlgoSettingsActions.ClearState, (): State => initialState),
  on(AlgoSettingsActions.GetAlgoSettings, (state): State => ({ ...state, loading: true })),
  on(
    AlgoSettingsActions.GetAlgoSettingsSuccess,
    (_state, { payload, projectID }): State => ({
      spanById: payload.spanById,
      metaCuratorList: payload.metaCuratorList,
      valueSuggestionByAdamType: payload.valueSuggestionByAdamType,
      columnSuggestionByAdamType: payload.columnSuggestionByAdamType,
      changes: payload.changes,
      selectedRow: null,
      loading: false,
      inProgress: false,
      lastProjectID: projectID
    })
  ),
  on(AlgoSettingsActions.GetAlgoSettingsFailed, (state): State => ({ ...state, loading: false })),
  on(AlgoSettingsActions.SetSelectedRow, (state, { payload: selectedRow }): State => ({ ...state, selectedRow })),
  on(AlgoSettingsActions.ApplyChanges, (state, { annotateID, changes }): State => {
    if (!Object.keys(changes).length) {
      const changeWithoutAnnotateID = { ...state.changes };
      delete changeWithoutAnnotateID[annotateID];
      return { ...state, changes: changeWithoutAnnotateID };
    }
    return { ...state, changes: { ...state.changes, [annotateID]: changes } };
  }),
  on(AlgoSettingsActions.AlgoAccept, (state): State => ({ ...state, loading: true })),
  on(AlgoSettingsActions.AlgoAcceptSuccess, (state, { tlfAnnotationID }): State => {
    const changes = { ...state.changes };
    const metaCuratorList = state.metaCuratorList.map((data) =>
      data._id === tlfAnnotationID ? { ...data, status: 'accept' } : data
    );
    delete changes[tlfAnnotationID];
    return { ...state, selectedRow: null, metaCuratorList, changes, loading: false };
  }),
  on(AlgoSettingsActions.AlgoAcceptFailed, (state): State => ({ ...state, loading: false })),
  on(AlgoSettingsActions.AlgoMoveToReview, (state): State => ({ ...state, loading: true })),
  on(AlgoSettingsActions.AlgoMoveToReviewSuccess, (state, { tlfAnnotationID }): State => {
    const changes = { ...state.changes };
    const metaCuratorList = state.metaCuratorList.map((data) =>
      data._id === tlfAnnotationID ? { ...data, status: 'review' } : data
    );
    // delete changes[tlfAnnotationID];
    return { ...state, selectedRow: null, metaCuratorList, changes, loading: false };
  }),
  on(AlgoSettingsActions.AlgoMoveToReviewFailed, (state): State => ({ ...state, loading: false })),
  // on(AlgoSettingsActions.AlgoAcceptAll, (state): State => ({ ...state, loading: true })),
  // on(AlgoSettingsActions.AlgoAcceptAllSuccess, (state): State => {
  //   return { ...state, changes: {}, spanById: {}, metaCuratorList: [], loading: false };
  // }),
  // on(AlgoSettingsActions.AlgoAcceptAllFailed, (state): State => ({ ...state, loading: false })),
  on(AlgoSettingsActions.AlgoReprocess, (state): State => ({ ...state, loading: true })),
  on(AlgoSettingsActions.AlgoReprocessSuccess, (state): State => {
    return { ...state, changes: {}, spanById: {}, metaCuratorList: [], loading: false, inProgress: true };
  }),
  on(AlgoSettingsActions.AlgoReprocessFailed, (state): State => ({ ...state, loading: false })),
  on(AlgoSettingsActions.AlgoReprocessOneAnnotate, (state): State => ({ ...state, loading: true })),
  on(AlgoSettingsActions.AlgoReprocessOneAnnotateSuccess, (state): State => {
    return { ...state, changes: {}, spanById: {}, metaCuratorList: [], loading: false, inProgress: true };
  }),
  on(AlgoSettingsActions.AlgoReprocessOneAnnotateFailed, (state): State => ({ ...state, loading: false })),
  on(
    AlgoSettingsActions.SetAlgoSettings,
    (state, { payload }): State => ({
      ...state,
      metaCuratorList: payload.data.map((row) => ({
        _id: row.id,
        name: row.fileName,
        number: row.tlfNumber,
        index: row.tlfIndex,
        checkKey: row.checkName,
        discrepancies: row.discrepanciesCount,
        missingColumns: row.missingColumns,
        tlfId: row.tlfId,
        status: row.status
      }))
    })
  ),
  on(AlgoSettingsActions.AddSpans, (state, { tlfAnnotationID, spans }): State => {
    const newSpans = { ...state.spanById[tlfAnnotationID] };
    for (const key in spans) {
      newSpans[key] = spans[key];
    }
    return {
      ...state,
      spanById: {
        ...state.spanById,
        [tlfAnnotationID]: newSpans
      }
    };
  }),
  on(AlgoSettingsActions.RemoveSpansByKeys, (state, { tlfAnnotationID, keys }): State => {
    const spans = { ...state.spanById[tlfAnnotationID] };
    keys.forEach((key) => delete spans[key]);
    return {
      ...state,
      spanById: {
        ...state.spanById,
        [tlfAnnotationID]: spans
      }
    };
  }),
  on(AlgoSettingsActions.ResetSpans, (state, { tlfAnnotationID, spans }): State => {
    return {
      ...state,
      spanById: {
        ...state.spanById,
        [tlfAnnotationID]: spans
      }
    };
  })
);

export const reducer = (state: State, action: Action): State => algoSettingReducer(state, action);
